/**
 * Guitar capo helpers.
 * Capo is a personal, device-local preference — it transposes the DISPLAYED
 * chord shapes down by the capo fret count without changing the song's
 * actual (sounding) key, and is never synced to other users.
 */
const CAPO_STORAGE_PREFIX = 'song_capo_';

export const CAPO_MIN = 0;
export const CAPO_MAX = 11;

/** Read the locally-saved capo preference for a song, or null if none set. */
export function getStoredCapo(songId) {
  if (!songId) return null;
  try {
    const v = localStorage.getItem(CAPO_STORAGE_PREFIX + songId);
    return v !== null ? parseInt(v, 10) : null;
  } catch {
    return null;
  }
}

/** Save the capo preference for a song to this device only. */
export function setStoredCapo(songId, value) {
  if (!songId) return;
  try {
    localStorage.setItem(CAPO_STORAGE_PREFIX + songId, String(value));
  } catch {
    /* storage unavailable/quota */
  }
}

/** Parse a {capo: N} ChordPro directive from raw content, or null if absent. */
export function parseCapoDirective(content) {
  if (!content) return null;
  const m = content.match(/^\{capo\s*:\s*(\d+)\s*\}/im);
  if (!m) return null;
  const n = parseInt(m[1], 10);
  return Number.isFinite(n) ? n : null;
}
